export const getEntity = function getEntity () {
  const s = this.getState ? this.getState() : this.state
  const root = s.root || s
  const parts = window.location.pathname.split('/').filter(Boolean)
  const type = parts[0] === 'firm' ? 'firm' : 'lawyer'
  const slug = parts[1] || new URLSearchParams(window.location.search).get('slug') || ''
  if (!slug) return null
  if (type === 'firm') return (root.firms || []).find(x => x.slug === slug)
  return (root.lawyers || []).find(x => x.slug === slug)
}

export const isFirmPage = function isFirmPage () {
  const parts = window.location.pathname.split('/').filter(Boolean)
  return parts[0] === 'firm'
}

export const getFirmForEntity = function getFirmForEntity (firmId) {
  const s = this.getState ? this.getState() : this.state
  const root = s.root || s
  return (root.firms || []).find(f => f.id === firmId)
}
